import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import stylegeneral from '../../styles/general.module.scss'
import PictureComponent from "../../components/PictureComponent";
import styleform from '../../styles/form.module.scss';
import stylebtn from '../../styles/btn.module.scss';
import { Login } from "../../api/Autenticacion";
import ParrafoComponent from "../../components/ParrafoComponent";
import LoaderComponent from "../../components/LoaderComponent";
import { useAuth } from "../../context/AuthContext";
import { guardarToken } from "../../helpers/tokenSesion";
import { RUTA_INICIO } from "../../constants/rutas";
const LoginPage = () => {
    const { isAuthenticated, loading: cargandoSesion } = useAuth();
    const navigate = useNavigate();

    // Con una sesión vigente (ej. al abrir la app instalada) se entra directo
    useEffect(() => {
        if (!cargandoSesion && isAuthenticated) navigate(RUTA_INICIO, { replace: true });
    }, [cargandoSesion, isAuthenticated, navigate]);

    const [errorr, setError] = useState('');
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        usernombre: '',
        passward: ''
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };



    // codigo javaStrip
    const login = () => {
        setloading(true);
        Login(formData.usernombre, formData.passward).then((response) => {
            guardarToken(response.data.token);
            window.location.href = RUTA_INICIO
            setloading(false);
            localStorage.setItem('iduser', response.data.user.id);
            localStorage.setItem('notificacioneslocal', true);
        })
            .catch(error => {
                setloading(false);
                if (error.response) {
                    // Error de respuesta del servidor
                    setError(error.response.data.msg);
                    console.log(error.response);
                } else {
                    // Sin respuesta: no hay internet o el servidor no está disponible
                    setError('No hay conexión. Para iniciar sesión necesitas internet.');
                }
            });
    }

    return (
        <Fragment>
            <div className={stylegeneral.fondoLoginFoto}>
                    <div className={`${styleform.loginContainer}`}>
                        {loading ? <LoaderComponent styleGruop="h-auto" /> :
                            <Fragment>
                                <div className="d-flex justify-content-center mb-4">
                                    <div className={styleform.loginLogo}>
                                        <PictureComponent src="/img/logo.png" alt="logo" styleGroup="w-100" />
                                    </div>
                                </div>
                                <form action="">
                                    <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">{errorr}</ParrafoComponent>

                                    <div className={`${styleform.containar_Input} mb-4`}>
                                        <label htmlFor="username" className="fw400 WorkSans">Usuario</label>
                                        <div className={styleform.inputConIcono}>
                                            <Icon icon="mdi:account-outline" />
                                            <input
                                                id="username"
                                                type="text"
                                                name="usernombre"
                                                autoComplete="username"
                                                value={formData.usernombre}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className={`${styleform.containar_Input} mb-4`}>
                                        <label htmlFor="pass" className="fw400 WorkSans">Contraseña</label>
                                        <div className={styleform.inputConIcono}>
                                            <Icon icon="mdi:lock-outline" />
                                            <input
                                                id="pass"
                                                type="password"
                                                name="passward"
                                                autoComplete="current-password"
                                                value={formData.passward}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                   {/*} <div className="form-check d-flex justify-content-center mb-3">
                                        <input className="form-check-input me-2" type="checkbox" value="" id="recorddata" />
                                        <label className="form-check-label" htmlFor="recorddat">
                                            Recordar contraseña
                                        </label>
                                    </div>*/}

                                    <div className="d-flex justify-content-center pt-2 pb-3">
                                        <button type="button" onClick={login} className={`${stylebtn.btn} ${stylebtn.primary} ${styleform.loginBtn}`}>Ingresar</button>
                                    </div>

                                    <ParrafoComponent styleGroup={`text-center WorkSans mb-0 ${styleform.loginLinkTexto}`}>
                                        ¿Olvidaste tu contraseña?
                                    </ParrafoComponent>
                                </form>
                            </Fragment>

                        }

                    </div>
            </div>
        </Fragment>
    )
}

export default LoginPage;